import { render, staticRenderFns } from "./pg-updextend.vue?vue&type=template&id=028e6946&scoped=true"
import script from "./pg-updextend.vue?vue&type=script&lang=js"
export * from "./pg-updextend.vue?vue&type=script&lang=js"
import style1 from "./pg-updextend.vue?vue&type=style&index=1&id=028e6946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e6946",
  null
  
)

export default component.exports